
import { createSlice } from "@reduxjs/toolkit";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BallotIcon from '@mui/icons-material/Ballot';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows';
const organizationSlice = createSlice({
    name: 'organization',
    initialState: [ 
        {
            id: 'hospital' ,
            Label: 'Hospital',
            options: [
                {
                    id: 'dashboard',
                
                    Label: 'Modules',
                    icon: <DashboardCustomizeIcon />,
                    to: '/home',
                    menu: [
                        {
                           
                        id: 'Dashboard',
                        Label: 'Dashboard',

                        to: '/home',
                                
                            
                        },
                            {
                        id: 'Custom Charts',
                        Label: 'Custom Charts',
                        to: '/custom-charts'
                    },
                     
                    ]
                },
              
            {
                id: 'Browser Control',
                Label: 'Browser Control',
                icon: <BadgeIcon />,
               
                menu: [
                    // {
                    //     id: 'Users',
                    //     Label: 'Users',
                    //     to: '/user-management'
                    // },
                    // {
                    //     id: 'Roles',
                    //     Label: 'Roles',
                    //     to: '/roles'
                    // },
                    {
                        id: 'Groups',
                        Label: 'Groups',
                        to: '/groups'
                    },
                      {
                        id: 'Policies',
                        Label: 'Policies',
                        to: '/policies'
                    },
   {
                        id: 'Whitelist Urls',
                        Label: 'Whitelist Urls',
                        to: '/urls'
                    },
                    //    {
                    //     id: 'Protocols',
                    //     Label: 'Protocols',
                    //     to: '/protocols'
                    // },
                        {
                        id: 'Active Sessions',
                        Label: 'Active Sessions',
                        to: '/active-sessions'
                    },
                         {
                        id: 'Browser Updates',
                        Label: 'Browser Updates',
                        to: '/browser-updates'
                    },
                             {
                        id: 'Devices',
                        Label: 'Devices',
                        to: '/devices'
                    },
                                 {
                        id: 'Questionnaire',
                        Label: 'Questionnaire',
                        to: '/questionnaire'
                    },
            ],
        },
    //     {
    //         id: 'Patches',
    //         Label: 'Patches',
    //         icon: <LaptopWindowsIcon />,
           
    //         menu: [
    //             {
    //                 id: 'Assets',
    //                 Label: 'Assets',
    //                 to: '/asset'
    //             },
    //             {
    //                 id: 'Bulk-Import',
    //                 Label: 'Bulk-Import',
    //                 to: '/bulk-import'
    //             },

    //     ],
    // },
//         {
//             id: 'Settings',
//             Label: 'Settings',
//             icon: <SettingsIcon />,
           
//             menu: [
//                 {
//                     id: 'Scheduler',
//                     Label: 'Scheduler',
//                     to: '/scheduler'
//                 },
//                 {
//                     id: 'Passwords',
//                     Label: 'Password Manager',
//                     to: '/passwords'
//                 },
            

//         ],
//     },
//     {
//         id: 'Notifications',
//         Label: 'Notifications',
//         icon: <CircleNotificationsIcon />,
       
//         menu: [
 
//             {
//                 id: 'Email Notification',
//                 Label: 'Email Notification',
//                 to: '/email-scheduler'
//             },
//             {
//                 id: 'All Notification',
//                 Label: 'All Notification',
//                 to: '/notifications'
//             },

//     ],
// },
{
    id: 'User Settings',
    Label: 'User Settings',
    icon: <SupervisorAccountIcon />,
   
    menu: [
        {
            id: 'Role',
            Label: 'Role',
            to: '/role'
        },
        {
            id: 'User Management',
            Label: 'User Management',
            to: '/user-management'
        },
        // {
        //     id: 'Permission',
        //     Label: 'Permission',
        //     to: '/permission'
        // },


],
},
            ],




        }
    ]
});

export default organizationSlice.reducer
